import { render, staticRenderFns } from "./HomeUser.vue?vue&type=template&id=312c5e34"
import script from "./HomeUser.vue?vue&type=script&lang=js"
export * from "./HomeUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports